import {Component, OnInit} from '@angular/core';
import {LoginService} from '../../services/login.service';

@Component({
  selector: 'app-airportparking',
  styleUrls: ['./airportparking.component.css'],
  templateUrl: './airportparking.component.html',
})
export class AirportparkingComponent implements OnInit {

  constructor(private loginService: LoginService) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
  }
}
